class ProductIcons extends HTMLElement {
  constructor() {
    super();
    this.productHandle = this.querySelector('.product-icons').dataset.productHandle;
    this.productIcons = this.querySelectorAll('.icon');
    this.renderIcons();
  }

  async fetchProductTags() {
    let tags = null;

    try {
      const response = await fetch(`${window.Shopify.routes.root}products/${this.productHandle}?view=tag-mapping`);
      tags = JSON.parse(await response.text());
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }

    return tags;
  }

  async renderIcons() {
    const productTags = await this.fetchProductTags();
    this.productIcons.forEach((icon) => {
      const { tag } = icon.dataset;
      const tagItem = productTags.tags.find((item) => item.tag === tag);
      if (tagItem) {
        const img = document.createElement('img');
        img.src = `${window.shopifyFileUrl}${tagItem.file_name}`;
        img.alt = tagItem.alt_text;
        img.setAttribute('loading', 'lazy');
        img.setAttribute('width', '40');
        img.setAttribute('height', '40');
        const span = document.createElement('span');
        span.textContent = tagItem.user_facing_text;
        icon.appendChild(img);
        icon.appendChild(span);
      }
    });
  }
}

// eslint-disable-next-line no-unused-expressions
customElements.get('product-icons') || customElements.define('product-icons', ProductIcons);
